import { LAYOUT } from "@/router/constant";
import { AppRouteModule } from "@/router/types";
import { t } from '@/hooks/web/useI18n';
import { useLocale } from "@/hooks/web/useLocale";

const message: AppRouteModule = {
    path: '/message',
    name: 'Message',
    component: LAYOUT,
    redirect: '/message/index',
    meta: {
        orderNo: 11,
        icon: 'inform',
        title: t('routes.index.message.message'),
        // hide: useLocale().hideComponentForCurrentLocale.value,
    },
    children: [
        {
            path: 'index',
            name: 'MessageIndex',
            component: () => import('@/views/menu/message/index.vue'),
            meta: {
                title: t('routes.index.message.index'),
            },
        },
    ],
}

export default message;